import { Component, Input } from '@angular/core';
import { PartnerProfileComponent } from 'app/partner';
import { CustomWindow } from 'app/@types';

declare let window: CustomWindow;

@Component({
    selector: 'partner-profile-email-tab',
    templateUrl: './partner-profile-email-tab.component.html',
    styleUrls: ['./partner-profile-email-tab.component.scss']
})
export class PartnerProfileEmailTabComponent {
    public adminUrl: string = window['adminUrl'];

    @Input()
    public parent!: PartnerProfileComponent;
}
